module.exports = __webpack_public_path__ + "static/media/meter_2.e563fd76.png";